import React from 'react';

const NoResults = () => <div>No results found.</div>;

export default NoResults;
